import DELIVERY from '../fragments/delivery';

const IMG = '/images/subscription';

const page = {
  slug: 'prepared-meal-subscription',
  title: 'Subscriptions',
  hero: {
    title: 'Subscriptions',
    image: `${IMG}/hero.webp`,
  },
  blocks: [
    {
      type: 'text',
      paragraphs: [
        `Home deliveries: ${DELIVERY.short}, or multi-day delivery`,
        'Office deliveries: Choice of Monday, Tuesday or Thursday before 12pm, or multi-day delivery',
        'Looking for a different delivery time or location? Contact us.',
        `Currently serving ${DELIVERY.zones}.`,
        'Cancel anytime.',
      ],
    },
    {
      type: 'cards',
      heading: 'Subscription Plans',
      items: [
        {
          title: 'Weekly Tailored Meals',
          price: 'from $196.99/week',
          lines: [
            'Pick from 5-7 days of delicious meals, tailored to fit your specific nutritional needs',
            'Option of breakfast & snacks',
            'Worry and mess free!',
            'Variety is the spice of life- our menu changes weekly!',
          ],
          image: `${IMG}/card-weekly.webp`,
          imageAlt: 'Person holding a glass food storage container with grilled salmon',
          cta: {
            label: 'Learn More',
            href: 'https://www.getsquarefare.com/this-weeks-meals/p/tailored-meals',
          },
        },
        {
          title: 'For The Work Week',
          price: 'from $53.99/week',
          lines: [
            'Pick from 3-5 days of meals. This subscription affords you the time to really enjoy that relaxing lunch break!',
            'Choose what meals you want made for you, pick breakfast, lunch and/or dinner.',
            'No more soggy sandwiches and boring salads!',
          ],
          image: `${IMG}/card-work-week.webp`,
          imageAlt: 'A plate of pasta with cream sauce, mushrooms, cheese and a basil leaf',
          cta: {
            label: 'Learn More',
            href: 'https://www.getsquarefare.com/this-weeks-meals/p/tailored-meals-raf3w',
          },
        },
        {
          title: 'The Family Plan',
          price: 'from $41.98/week',
          lines: [
            'Healthy, organic, and clean meals for the entire family. Choose how many people you want meals for and how many dishes you want for the week.',
            "Portions are based on standard 600 kcals size and just specify your family's likes/dislikes/restrictions at checkout!",
            'Enjoy stress and mess-free meals that are ready to eat in minutes!',
          ],
          image: `${IMG}/card-family.webp`,
          imageAlt: 'A diverse group of people gathered around a table at a family gathering',
          cta: {
            label: 'Learn More',
            href: 'https://www.getsquarefare.com/this-weeks-meals/p/tailored-meals-a4hy3-s4fng',
          },
        },
      ],
    },
    {
      type: 'list',
      heading: 'Good To Know',
      ordered: false,
      items: [
        DELIVERY.menuDay,
        DELIVERY.changes,
        'Heat your meal 2 minutes in the microwave, or 5-10 minutes in the oven',
        'Want to skip a week? No problem! Just access your account and make the change online or shoot us an email: claire@getsquarefare.com',
        'Want to cancel your subscription? Simply go to your account or email us: claire@getsquarefare.com',
        'Our meal containers are compostable, our sauce containers are recyclable',
        `Deliveries run ${DELIVERY.days}. Let us know if we should communicate anything to our delivery team.`,
        "We're excited to cook for you!",
      ],
    },
    {
      type: 'split',
      tone: 'warm',
      image: `${IMG}/detail.webp`,
      imageAlt: 'A prepared Square Fare meal ready to eat',
      imageSide: 'right',
      groups: [
        {
          heading: 'Calling All Runners',
          paragraphs: [
            "Whether you're gearing up for a big race, or simply wanting to level up your nutrition and optimize your training, we have a special option just for you!",
            'Schedule your initial free discovery call with our sports dietician, Amity. To get started, shoot her an email at: eat.to.run.nutrition@gmail.com',
          ],
        },
      ],
      cta: { label: 'Learn More', to: '/meal-plans-for-runners' },
    },
    {
      type: 'text',
      heading: "If you haven't already, make sure to take our quiz to get the most out of Square Fare.",
      paragraphs: [
        'We will tailor your plan to your specific needs detailed by our nutritionists and based on your quiz answers.',
      ],
    },
    { type: 'cta', label: 'Take the Quiz', to: '/quiz' },
    {
      type: 'text',
      paragraphs: [
        "Don't be shy — get in touch. You can also email Claire directly at claire@getsquarefare.com or call (917) 679-5306.",
      ],
    },
    {
      type: 'ctaGroup',
      heading: 'Still Have Questions?',
      actions: [
        { label: 'Contact Us', to: '/contact-form-general' },
        { label: 'Visit FAQ', to: '/faqs'},
      ],
    },
  ],
};

export default page;
